import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from '../../moduleBreadcrumbs';

export default [
  ...buildCrudRoutes({
    baseName: 'adqTable',
    basePath: 'adq-table',
    card: {
      title: 'Mesa de análise',
      icon: 'home',
    },
    moduleActive: 'contacard',
    subModuleActive: 'adq',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
      {
        text: 'Mesa de análise',
        disabled: true,
      },
    ],
    listRoute: {
      pageContent: () => import('Modules/contacard/adq/table/AdqTableList.vue'),
      filterComponent: () => import('Modules/contacard/adq/table/AdqTableFilter.vue'),
      navigateBackRoute: 'contacard.submodules.list',
      pageTitle: 'Mesa de Análise',
    },
  }),
];
